import React from "react";
import { Form, Button, InputNumber } from "antd";

const FormBAtchRider = (props) => {
  return (
    <Form initialValues={props.initialValues} onFinish={props.onFinish}>
      <div className="customTable">
        <table>
          <thead>
            <tr>
              <th>No.</th>
              <th>Rider Display ID</th>
              <th>Batch Level</th>
            </tr>
          </thead>
          <tbody>
            <Form.List
              name={"rider_batchs_data"}
              initialValues={props.initialValues}
            >
              {(fields) => (
                <>
                  {fields.map((field, index) => {
                    return (
                      <tr key={field.key}>
                        <td>{index + 1}</td>
                        <td>
                          <Form.Item
                            key={field.key}
                            name={[field.name, "riderId"]}
                            // label={`${index + 1}-rider-display-id`}
                            rules={[
                              {
                                required: true,
                                message: "Rider Display ID is Required",
                              },
                            ]}
                          >
                            <InputNumber placeholder="Rider Display ID" />
                          </Form.Item>
                        </td>
                        <td>
                          <Form.Item
                            key={field.key}
                            name={[field.name, "batchLevel"]}
                            rules={[
                              {
                                required: true,
                                message: "Batch Level is Required",
                              },
                            ]}
                          >
                            <InputNumber
                              placeholder="Batch Level"
                              min={1}
                              max={6}
                              // prefix={<ClockCircleOutlined />}
                            />
                          </Form.Item>
                        </td>
                      </tr>
                    );
                  })}
                </>
              )}
            </Form.List>
            {props.initialValues.rider_batchs_data.length > 0 ? (
              <tr>
                <td colSpan={3}>
                  <Form.Item>
                    <Button
                      className="submit"
                      htmlType="submit"
                      loading={props.MBtnLoading}
                    >
                      Submit
                    </Button>
                  </Form.Item>
                </td>
              </tr>
            ) : (
              ""
            )}
          </tbody>
        </table>
      </div>
    </Form>
  );
};

export default FormBAtchRider;
